<template>
    <div>
        <div class="grid">
            <div
                v-for="column in columns"
                class="column w-full md:w-1/3 flex flex-col items-center"
            >
                <img
                    :src="column.image"
                    :alt="column.alt"
                    class="mt-2xl mb-md md:mt-0"
                    style="max-height: 180px;"
                >

                <h3 v-if="column.headline">{{ column.headline }}</h3>

                <ul v-if="column.list" class="list-reset mb-xl w-full">
                    <li v-for="listItem in column.list" class="mb-sm flex items-baseline">
                        <font-awesome-icon icon="circle" class="is-small text-accent-yellow mr-md flex-none" />
                        {{ listItem }}
                    </li>
                </ul>

                <template v-if="hasContent(column.text)">
                    <button
                        :class="selectedColumn === column ? 'bg-neutral-darker text-white' : 'is-primary'"
                        type="button"
                        class="mt-auto btn btn-md max-w-xs"
                        @click="selectColumn(column)"
                    >
                        <span v-if="selectedColumn === column">{{ lang('Dölj','Hide') }}</span>
                        <span v-else>{{ lang('Läs mer','Read more') }}</span>
                    </button>

                    <div v-if="selectedColumn === column" class="my-xl card md:hidden">
                        <!-- eslint-disable vue/no-v-html -->
                        <div v-html="selectedColumn.text" />
                    </div>
                </template>
            </div>
        </div>
        <div v-if="selectedColumn" class="mt-3xl card hidden md:block">
            <!-- eslint-disable vue/no-v-html -->
            <div v-if="hasContent(selectedColumn.text)" v-html="selectedColumn.text" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            columns: {
                required: true,
                type: Array,
            },
        },
        data() {
            return {
                selectedColumn: null,
            };
        },
        methods: {
            selectColumn(column) {
                if (column === this.selectedColumn) {
                    this.selectedColumn = null;
                    return;
                }

                this.selectedColumn = column;
            },
            hasContent(string) {
                return string && string.replace(/<\/?[^>]+(>|$)/g, '') !== '';
            },
        },
    };
</script>
